import { NavLink, useLocation } from "react-router-dom";
import { MessageSquareWarning, FileClock } from "lucide-react";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";

import { Tooltip, TooltipContent, TooltipTrigger } from "../components/ui/tooltip";
import { cn } from "../lib/utils";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";

function Sidebar() {
	const location = useLocation();

	const contradictory = useSelector((state: RootState) => state.analysis.contradictory);
	const missing = useSelector((state: RootState) => state.analysis.missing);
	const processed = useSelector((state: RootState) => state.analysis.processed);

	const analysis = !!contradictory || !!missing || !!processed;

	const routes = [
		{
			label: "Home",
			icon: HomeIcon,
			href: analysis ? "/analyze" : "/",
		},
		{
			label: "Track Changes",
			icon: FileClock,
			href: "/processed",
		},
		{
			label: "Manage Playbook",
			icon: LibraryBooksIcon,
			href: location.pathname.startsWith("/upload") ? "/upload" : "/manage-playbook",
		},
		{
			label: "Settings",
			icon: SettingsIcon,
			href: "/settings",
		},
		{
			label: "Contact Us",
			icon: MessageSquareWarning,
			href: "/info",
		},
	];

	return (
		<div className="flex flex-col items-center gap-5">
			{routes.map((route) => {
				return (
					<Tooltip key={route.label}>
						<TooltipTrigger>
							<NavLink
								to={route.href}
								className={({ isActive }) =>
									cn("w-full p-3 grid items-center text-gray-500 hover:text-primary", isActive && "text-primary")
								}
							>
								<route.icon strokeWidth={2.5} />
							</NavLink>
						</TooltipTrigger>
						<TooltipContent side="right">{route.label}</TooltipContent>
					</Tooltip>
				);
			})}
		</div>
	);
}

export { Sidebar };
